// ABOUTME: Renders the authenticated user's company selection menu.
// ABOUTME: Switches the active company while preserving navigation state behavior.
import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Divider from "@material-ui/core/Divider";
import { useTranslation } from "react-i18next";
import { AuthProvider, useAuthState } from "_ReactContext/AuthContext";
// import { queryCache } from "react-query";
import { QueryCache } from "react-query";
import { getCompaniesInAlphabeticalOrder } from "./ChangeCompany.helpers";

// const queries = queryCache.refetchQueries(inclusiveQueryKeyOrPredicateFn, {
//     exact,
//     throwOnError,
//     force
// });
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: "100%",
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper
        },
        menuTitle: {
            fontWeight: "bold"
        }
    })
);

interface IProps {
    anchorEl: null | HTMLElement;
    closeMenu: any;
}

export default function ChangeCompany(props: IProps) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const { company, allCompanies, changeCompany } = useAuthState();
    const [selectedCompany, setSelectedCompany] = React.useState(
        company.companyId
    );

    const [t, i18n, readyTranslation] = useTranslation("CHANGECOMPANY", {
        useSuspense: false
    });

    if (props.anchorEl !== null && anchorEl === null) {
        setAnchorEl(props.anchorEl);
    } else if (props.anchorEl === null && anchorEl !== null) {
        setAnchorEl(null);
    }

    const handleMenuItemClick = (
        event: React.MouseEvent<HTMLElement>,
        index: number
    ) => {
        const queryCache = new QueryCache();

        queryCache.clear();
        changeCompany(index);
        setSelectedCompany(index);
        props.closeMenu();
    };

    const handleClose = () => {
        props.closeMenu();
    };

    return (
        <div className={classes.root}>
            <Menu
                id="lock-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem className={classes.menuTitle}>
                    {t("changecompany")}
                </MenuItem>
                <Divider />
                {getCompaniesInAlphabeticalOrder(allCompanies).map((c: any) => {
                    const keyvalue = c.pk.split(":")[1];

                    return (
                        <MenuItem
                            key={keyvalue}
                            selected={selectedCompany === keyvalue}
                            onClick={(event) =>
                                handleMenuItemClick(event, keyvalue)
                            }
                        >
                            {c.CompanyFancyName}
                        </MenuItem>
                    );
                })}
            </Menu>
        </div>
    );
}
